import NavigationRoute from "./Routes/NavigationRoute";
import "./Css/style.css";
// import OneSignal from "react-onesignal";
import { useEffect } from "react";
const OneSignalAppId = "d6742de8-e45e-457e-9474-d3cc3436e9c0";
function App() {
  // useEffect(() => {
  //   OneSignal.init({
  //     appId: OneSignalAppId,
  //     safari_web_id: "web.onesignal.auto.5f0d689b-f65a-4365-8770-a9853d53b981",
  //     notifyButton: {
  //       enable: true,
  //     },
  //     allowLocalhostAsSecureOrigin: true,
  //   });
  //   console.log("op")
  // }, []);

  return (
    <div>
      {" "}
      <NavigationRoute />{" "}
    </div>
  );
}

export default App;
